import { useSearchParams } from 'react-router-dom'
import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider'
import { translate } from '@/i18n/index'
import { isSupportedLocale, PRIVANA_FALLBACK_LOCALE } from '../../../shared/locales.mjs'

// Public guest links keep their existing English fallback and never inherit the
// signed-in operator's locale. An explicit recipient/visitor lang is presentation
// only; tokens, checkout payloads and notification recipient rules are unchanged.
export function usePaymentPresentationLocale(publicGuest = false) {
  const [params] = useSearchParams()
  const context = useOptionalPrivanaI18n()
  const explicit = params.get('lang')
  const locale = isSupportedLocale(explicit) ? explicit : publicGuest ? PRIVANA_FALLBACK_LOCALE : context.locale
  return { locale, t: (key, values) => translate(key, locale, values) }
}
